import React from "react";
import { useState } from 'react'
import { Image } from "@arctheme-components/elements/Image/Image";

export const ImageZoom = ({ settings, image, index, isCarousel = false, zoomLevel = 2 }) => {
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [[imgWidth, imgHeight], setImgSize] = useState([0, 0]);
  const [[x, y], setXY] = useState([0, 0]);

  const magnifierHeight = 424;
  const magniferWidth = 367;

  const mouseEnter = (e) => {
    const el = e.currentTarget;
    const { width, height } = el.getBoundingClientRect();
    setImgSize([width, height]);
    setShowMagnifier(true);
  }

  const mouseLeave = (e) => {
    e.preventDefault();
    setShowMagnifier(false);
  }

  const mouseMove = (e) => {
    const el = e.currentTarget;
    const { top, left } = el.getBoundingClientRect();

    const x = e.pageX - left - window.scrollX;
    const y = e.pageY - top - window.scrollY;

    setXY([x, y]);
  }

  return (
    <div className="relative overflow-hidden">
      <div
        onMouseEnter={(e) => mouseEnter(e)}
        onMouseLeave={(e) => mouseLeave(e)}
        onMouseMove={(e) => mouseMove(e)}
      >
        <Image
          key={index}
          imageUrl={image.url}
          alt={image.alt}
          isLazy={index < 1 ? settings.section.is_lazy_load : true}
        />
      </div>
      <div
        className={`absolute ${showMagnifier ? '' : 'hidden'} pointer-events-none opacity-100 border border-[#7A7A7A] bg-no-repeat h-[${magnifierHeight}px] w-[${magniferWidth}px]`}
        style={{
          backgroundImage: `url(${image.url})`,
          top: `${y - (magnifierHeight / 2)}px`,
          left: `${x - (magniferWidth / 3)}px`,
          backgroundSize: `${imgWidth * zoomLevel}px ${imgHeight * zoomLevel}px`,
          backgroundPositionX: `${(-x * zoomLevel) + (magniferWidth / 2)}px`,
          backgroundPositionY: `${(-y * zoomLevel) + (magnifierHeight / 2)}px`,
        }}
      >

      </div>
    </div>
  )
};

export default ImageZoom;